import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRoleCache } from './cache'
import { Logger, type RoleRemoveInput, type RoleRemoveSuccess, toResponseError } from '@terros/common'

const logger = new Logger('useRemoveRole')

export function useRemoveRole(): RemoveHookResponse<RoleRemoveInput> {
  logger.verbose('calling useRemoveRole')
  const cache = useRoleCache()
  const mutation = useTantalimMutation<RoleRemoveInput, RoleRemoveSuccess>({ url: '/role/remove' })

  async function remove(input: RoleRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearItem(input.roleId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
